import styled from "styled-components";
import { COLORS } from "../../../../../assets/constants/styles";

export const TabContent = styled.div`
  margin-top: 20px;
  padding: 20px;
  background-color: ${COLORS.white};
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const LogSection = styled.div`
  margin-bottom: 20px;
  width: 100%;
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: ${COLORS.black};
    padding-bottom: 8px;
  }
`;

export const SectionTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${COLORS.black};
  padding-bottom: 8px;
`;

export const ErrorMessage = styled.div`
  color: ${COLORS.danger};
  font-weight: 500;
  padding: 16px;
  background-color: ${COLORS.white};
  border-radius: 8px;
  margin-bottom: 16px;
  border: 1px solid ${COLORS.dangerLight};
  overflow-wrap: break-word;
  word-wrap: break-word;
`;
